export default __webpack_public_path__ + "static/media/Smiley.54a72457.svg";